var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-simple-table',[_c('thead',[_c('th',{staticClass:"text-left"},[_vm._v("Nombre")]),_c('th',{staticClass:"text-left"},[_vm._v("Categoria")])]),_c('tbody',[_vm._l((_vm.insumosNoUso),function(item,index){return [_c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.Nombre))]),_c('td',[_vm._v(_vm._s(item.categoria_name))])])]})],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }